"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionLockLock = /** @class */ (function (_super) {
    __extends(TableActionLockLock, _super);
    function TableActionLockLock(props) {
        return _super.call(this, props) || this;
    }
    TableActionLockLock.prototype.buttonClick = function () {
        if (this.props.onClick) {
            this.props.onClick();
        }
    };
    TableActionLockLock.prototype.getRenderObject = function () {
        if (this.props.hint) {
            return (React.createElement(antd_1.Tooltip, { placement: "bottom", title: React.createElement("div", null, this.props.hint), trigger: "hover" },
                React.createElement(antd_1.Popconfirm, { placement: "left", title: this.props.confirmText, okText: "\u0414\u0430", cancelText: "\u041D\u0435\u0442", onConfirm: this.buttonClick.bind(this) },
                    React.createElement(antd_1.Button, { shape: "circle", size: "small", icon: "lock", ghost: true, type: "danger", style: { marginLeft: "1px", marginRight: "1px" } }))));
        }
        else {
            return (React.createElement(antd_1.Popconfirm, { placement: "left", title: this.props.confirmText, okText: "\u0414\u0430", cancelText: "\u041D\u0435\u0442", onConfirm: this.buttonClick.bind(this) },
                React.createElement(antd_1.Button, { shape: "circle", size: "small", icon: "lock", ghost: true, type: "danger", style: { marginLeft: "1px", marginRight: "1px" }, disabled: this.props.disabled })));
        }
    };
    TableActionLockLock.prototype.render = function () {
        return (this.getRenderObject());
    };
    return TableActionLockLock;
}(React.Component));
exports.default = TableActionLockLock;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/table_actions/TableActionLockLock.tsx
// module id = 159
// module chunks = 0